import { Grid, TextField } from '@material-ui/core';
import React from 'react';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';

const ShareFlagsCreateGroupInput = ({
  inputGroupName,
  handleGroupInputChange,
  groupError
}) => {
  return (
    <>
      <Grid
        className="share-flags-modal__create-input"
        container
        alignItems="flex-end"
        style={{ marginBottom: groupError.hasError ? '4px' : '16px' }}
      >
        <Grid item className="share-flags-modal__create-input-icon">
          <figure>
            <CameraAltOutlinedIcon fontSize="large" />
          </figure>
        </Grid>
        <Grid item className="share-flags-modal__create-textfield-container">
          <TextField
            className="share-flags-modal__create-input-textfield"
            placeholder="Group Name..."
            inputProps={{ 'aria-label': 'create group input' }}
            value={inputGroupName}
            onChange={handleGroupInputChange}
          />
        </Grid>
      </Grid>
      {groupError.hasError ? (
        <Grid className="share-flags-modal__create-input-error" container>
          <Grid item>
            <span className="create-group-error">
              {groupError.errorMessage}
            </span>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default ShareFlagsCreateGroupInput;
